module.exports = __webpack_public_path__ + "fonts/hk-grotesk.semibold.41619258.ttf";